import style from './style.module.scss';
import { Switch, TimePicker } from 'antd';
import MinusIcon from '../../icons/Minus.svg?react';
import { Moment } from 'moment';
import { SwitchChangeEventHandler } from 'antd/lib/switch';

type SelectOpenHoursProps = {
    startTime: Moment | null;
    endTime: Moment | null;
    toggleState: boolean;
    onClickToggle?: SwitchChangeEventHandler;
    onChangeStartTime?: (value: Moment | null, dateString: string) => void;
    onChangeEndTime?: (value: Moment | null, dateString: string) => void;
};

export const SelectOpenHours = ({
    startTime,
    endTime,
    toggleState,
    onClickToggle,
    onChangeStartTime,
    onChangeEndTime,
}: SelectOpenHoursProps) => {
    return (
        <>
            <div className={style.select_hours}>
                <div className={style.open_toggle}>
                    <Switch checked={toggleState} onChange={onClickToggle} />
                    <div>Open</div>
                </div>
                <div className={style.time_range}>
                    <TimePicker
                        value={startTime}
                        onChange={onChangeStartTime}
                        placeholder="00:00"
                        suffixIcon={null}
                        format={'HH:mm'}
                        className={style.time_picker}
                    />
                    <MinusIcon />
                    <TimePicker
                        value={endTime}
                        onChange={onChangeEndTime}
                        placeholder="00:00"
                        suffixIcon={null}
                        format={'HH:mm'}
                        className={style.time_picker}
                    />
                </div>
            </div>
        </>
    );
};
